var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("travel-service-menu"),
      _c("h1", [
        _vm._v(_vm._s(_vm.$t("settings.travelService.offerAcceptance")))
      ]),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c("v-spacer"),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.availableUsersSelect,
                      label: _vm.$t("global.user")
                    },
                    model: {
                      value: _vm.selectedUser,
                      callback: function($$v) {
                        _vm.selectedUser = $$v
                      },
                      expression: "selectedUser"
                    }
                  }),
                  _c(
                    "v-btn",
                    { staticClass: "success ml-4", on: { click: _vm.addUser } },
                    [_vm._v(" " + _vm._s(_vm.$t("global.add")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          attrs: { headers: _vm.headers, items: _vm.approvalUsers },
          scopedSlots: _vm._u([
            {
              key: "item",
              fn: function(props) {
                return [
                  _c("tr", [
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            typeof _vm.availableUsers.find(function(v) {
                              return v.id === props.item.user_id
                            }) !== "undefined"
                              ? _vm.availableUsers.find(function(v) {
                                  return v.id === props.item.user_id
                                }).name
                              : null
                          ) +
                          " "
                      )
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            typeof _vm.availableUsers.find(function(v) {
                              return v.id === props.item.user_id
                            }) !== "undefined"
                              ? _vm.availableUsers.find(function(v) {
                                  return v.id === props.item.user_id
                                }).surname
                              : null
                          ) +
                          " "
                      )
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            typeof _vm.availableUsers.find(function(v) {
                              return v.id === props.item.user_id
                            }) !== "undefined"
                              ? _vm.availableUsers.find(function(v) {
                                  return v.id === props.item.user_id
                                }).login
                              : null
                          ) +
                          " "
                      )
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            typeof _vm.availableUsers.find(function(v) {
                              return v.id === props.item.user_id
                            }) !== "undefined"
                              ? _vm.availableUsers.find(function(v) {
                                  return v.id === props.item.user_id
                                }).email
                              : null
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "td",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.remove(props.item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("delete")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              }
            }
          ])
        },
        [
          _c(
            "v-alert",
            {
              attrs: {
                slot: "no-data",
                value: _vm.loaded,
                color: "info",
                icon: "info"
              },
              slot: "no-data"
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("settings.travelService.noAcceptancePersons")) +
                  " "
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-alert",
        {
          attrs: {
            color: "info",
            dark: "",
            value: _vm.approvalUsers.length > 0,
            icon: "info"
          }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("settings.travelService.automaticApprovalInfo")) +
              " "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }